import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import UserSearchBar from "../components/user/UserSearchBar";
import { connect } from "react-redux";
import Alert from "../../layout/Alert";
import SearchUser from "../../dashboard/SearchUser";
import ResponsiveContentWrapper from "../../layout/ResponsiveContentWrapper";
import Grid2 from "@mui/material/Grid2";
import { Box } from "@mui/material";

const UserInfoPage = ({ user, home, getReportbyId, getAllDevice, report }) => {
  const location = useLocation();
  const [showData, setShowData] = useState(false);
  const onSubmitSuccess = () => {
    setShowData(true);
  };
  const onSubmitFailure = () => {
    setShowData(false);
  };

  useEffect(() => {
    if (!showData && location.state) {
      setShowData(true);
    }
  }, []);

  return (
    <ResponsiveContentWrapper>
      <Box sx={{ px: { xs: 0.75, sm: 1.25 }, py: 0 }}>
        <Grid2 container spacing={2}>
          <Grid2 size={12}>
            <UserSearchBar
              onSubmitSuccess={onSubmitSuccess}
              onSubmitFailure={onSubmitFailure}
            />
          </Grid2>
        </Grid2>
        <Box sx={{ my: 2 }}>
          <Alert />
        </Box>
        {showData && <SearchUser user={user?.user} />}
      </Box>
    </ResponsiveContentWrapper>
  );
};

UserInfoPage.propTypes = {};

export default connect(
  (state) => ({
    user: state.user,
  }),
  {}
)(UserInfoPage);
